import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { getPageName } from '../../../utils/pageName';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { UserContext } from '../../../user/UserContext';
import styles from './lawyer_header_summary.module.scss';
import { useModal } from '../../../components/modal/useModal';
import { VerifyLawyerModal } from '../../verify-lawyer-modal/VerifyLawyerModal';
import { LawyerContext } from '../LawyerContext';

export const LawyerHeaderSummary: FC = () => {
  const sourcePage: string = getPageName();
  const {
    lawyerInfos,
    lawyerIsCurrentUser,
    lawyerIsVerified,
    lawyerName,
  } = useContext(LawyerContext);
  const { openModal } = useModal(modalProps => (
    <VerifyLawyerModal
      lawyerId={lawyerInfos.lawyerId}
      lawyerName={lawyerName}
      {...modalProps}
    />
  ));
  const openVerifyLawyerModal = () => {
    doctrineAnalytics('Professional WantToBeVerified', {
      source: 'professional_top',
    });
    openModal();
  };

  const { currentUser, loggedIn } = useContext(UserContext);
  const isNotLoggedInNotVerified =
    !currentUser.verified && !loggedIn && !lawyerIsVerified;
  const isLoggedInNotVerifiedNotCurrentUser =
    !currentUser.verified &&
    loggedIn &&
    !lawyerIsCurrentUser &&
    !lawyerIsVerified;
  const isLoggedInCurrentUserNotVerified =
    !currentUser.verified &&
    loggedIn &&
    lawyerIsCurrentUser &&
    !lawyerIsVerified;
  return (
    <>
      <div className={styles.subtitle}>
        <pre className={styles.description}>{lawyerInfos.summary}</pre>
      </div>
      {isNotLoggedInNotVerified && (
        <Hyperlink
          className="button clear small"
          href={`/inscription?source=professional_top&sourcePage=${sourcePage}`}
        >
          <FormattedMessage id="app.pages.lawyer.header.signUp" />
        </Hyperlink>
      )}
      {isLoggedInNotVerifiedNotCurrentUser && (
        <button
          className="button clear small"
          onClick={openVerifyLawyerModal}
          type="button"
        >
          <FormattedMessage id="app.pages.lawyer.header.verifyPage" />
        </button>
      )}
      {isLoggedInCurrentUserNotVerified && (
        <button
          className="button clear small"
          onClick={openVerifyLawyerModal}
          type="button"
        >
          <FormattedMessage id="app.pages.lawyer.header.verifyLawyer" />
        </button>
      )}
    </>
  );
};
